export enum Platform {
    DESKTOP_WEB = 'dw',
    MOBILE_WEB = 'mw',
}
